export default "__VITE_ASSET__CmtXA$_B__"